import { render, staticRenderFns } from "./deletePurchaseApply.vue?vue&type=template&id=3734e170&scoped=true"
import script from "./deletePurchaseApply.vue?vue&type=script&lang=js"
export * from "./deletePurchaseApply.vue?vue&type=script&lang=js"
import style0 from "./deletePurchaseApply.vue?vue&type=style&index=0&id=3734e170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734e170",
  null
  
)

export default component.exports